<template>
  <div class="investments-sum">
    <span class="investments-sum__label">{{ investmentsSumTitle }} — </span>
    <span class="investments-sum__value">{{ investmentsSumFormatted }} млрд руб.</span>
  </div>
</template>

<script>
  import { numberFormatter } from '@/common/utils/numberFormatter';

  export default {
    name: 'InvestmentSummary',
    props: {
      countryIds: {
        type: Array,
        default: () => [],
      },
      investmentsSum: {
        type: Number,
        required: true,
      },
    },
    computed: {
      investmentsSumTitle() {
        return this.countryIds?.length
          ? 'Сумма инвестиций по проектам'
          : 'Сумма инвестиций по проектам, в том числе СНГ';
      },
      investmentsSumFormatted() {
        return numberFormatter(this.investmentsSum, 'ru-RU', 3);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .investments-sum {
    margin-top: 32px;

    &__label {
      font: $fira-16;
    }

    &__value {
      font: $fira-16-M;
      color: $green;
    }
  }
</style>
